<div class="task-details">
	<div class="task-details-header">
		<div class="task-details-title-group">
			<h1
				class="task-details-title"
				tabindex="-1"
				[innerHTML]="displayTitleHtml() | sanitize">
			</h1>
			@if (isComplete()) {
				<div class="complete-badge">
					<i class="ficon-app-checkmark" aria-hidden="true"></i>
				</div>
			}
			@if (shouldShowPrivateSubheader()) {
				<div class="task-details-private" translate="task-details_private-to-you"></div>
			}
			@if (getModifierSubheader()) {
				<div class="task-details-modifier">
					({{getModifierSubheader()}})
				</div>
			}

			@if (hasInstructorRole()) {
				@if (!isInEditMode() && !isMobile() && !isNewActivityPreviewEditorDialogEnabled()) {
					<button
						type="button"
						class="btn primary-btn task-details-edit-button"
						(click)="toggleEditMode()"
						data-cy="task-details-edit-button"
						[attr.aria-label]="'activity-task-edit' | translate">
						<span class="task-details-edit-button-label">{{ 'activity-task-edit' | translate }}</span>
						<span class="task-details-edit-button-icon ficon-app-edit" aria-hidden="true"></span>
					</button>
				}
				@if (isInEditMode() && shouldShowInlineEditActions() && !isMobile()) {
					<div class="task-details-edit-actions">
						<button
							type="button"
							class="btn tertiary-btn cancel-btn task-details-cancel-button"
							(click)="onCancelEdit()"
							[disabled]="isSaving()"
							disabledInteractive
							[attr.aria-label]="'common_cancel' | translate">
							{{ 'common_cancel' | translate }}
						</button>
						<button
							type="button"
							class="btn primary-btn task-details-save-button"
							(click)="onSaveEdit()"
							[disabled]="isSaving()"
							disabledInteractive
							data-cy="task-details-save-btn"
							[attr.aria-label]="'common_save-and-close' | translate">
							@if (isSaving()) {
								<i class="ficon-spinner ficon-spin" aria-hidden="true"></i>
							}
							{{ 'common_save-and-close' | translate }}
						</button>
					</div>
				}
				@if (!isInEditMode() && isMobile() && !isNewActivityPreviewEditorDialogEnabled()) {
					<button
						type="button"
						class="btn primary-btn task-details-edit-button"
						(click)="toggleEditMode()"
						[attr.aria-label]="'common_edit' | translate">
						<span class="task-details-edit-button-icon ficon-app-edit" aria-hidden="true"></span>
					</button>
				}
			}
		</div>

			<task-list-navigator
				[currentTaskIndex]="currentTaskIndex()"
				[totalTasks]="totalTasks()"
				[isComplete]="isComplete()"
				[previousButtonLabelKey]="previousButtonLabelKey()"
				(navigateBack)="navigateBack.emit()"
				(navigateForward)="navigateForward.emit()"
				(openNavigator)="openNavigator.emit()">
		</task-list-navigator>
	</div>

	<div class="task-details-body">
		<div class="task-details-instructions">
			<div class="task-details-instructions-content">
				@if (toolInstructionsHtml()) {
					<div
						class="task-details-tool-instructions"
						[innerHTML]="toolInstructionsHtml() | sanitize">
					</div>
				}

				@if (shouldShowCustomInstructions()) {
					@if (isInEditMode()) {
						<task-instruction
							[taskId]="task().id"
							[inlineEditor]="shouldUseInlineTaskInstructions()"
							[startEditing]="isAddingInstructionForCurrentTask()"
							(onEdit)="handleEditInstructions($event)"
							(onRemove)="handleRemoveInstruction()">
						</task-instruction>
					} @else {
						<div
							#instructionsContent
							class="task-details-custom-instructions"
							[class.collapsed]="(expanded$ | async) === false"
							[innerHTML]="customInstructionsHtml() | sanitize">
						</div>
					}
				} @else {
					@if (isInEditMode() && shouldShowInlineTaskInstruction()) {
						<task-instruction
							[taskId]="task().id"
							[inlineEditor]="shouldUseInlineTaskInstructions()"
							[startEditing]="isAddingInstructionForCurrentTask()"
							(onEdit)="handleEditInstructions($event)"
							(onRemove)="handleRemoveInstruction()">
						</task-instruction>
					} @else if (isInEditMode()) {
						<button
							type="button"
							class="link-btn add-btn add-instruction-btn"
							translate="task-details_instructions"
							(click)="openAddTaskInstructionModal($event)">
						</button>
					}
				}
			</div>

				@if (shouldShowMedia() && !isInEditMode()) {
					<div class="task-details-media">
						<media-card
							[media]="currentTask().instruction.media"
							ariaLabelTitleKey="task-details_media-label">
						</media-card>
					</div>
				}

			@if ((showToggle$ | async) && !isInEditMode()) {
				<button
					type="button"
					class="task-details-toggle link-btn"
					(click)="toggleExpanded()">
					{{ (expanded$ | async) ? ('task-details_show-less' | translate) : ('task-details_show-more' | translate) }}
				</button>
			}
		</div>
	</div>

	@if (hasInstructorRole() && isInEditMode() && shouldShowInlineEditActions() && isMobile()) {
		<div class="task-details-mobile-edit-actions">
			<button
				type="button"
				class="btn tertiary-btn cancel-btn task-details-mobile-cancel-button"
				(click)="onCancelEdit()"
				[disabled]="isSaving()"
				disabledInteractive>
				{{ 'common_cancel' | translate }}
			</button>
				<button
					type="button"
					class="btn primary-btn task-details-mobile-save-button"
					(click)="onSaveEdit()"
					[disabled]="isSaving()"
					disabledInteractive>
					@if (isSaving()) {
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					}
				{{ 'common_save-and-close' | translate }}
			</button>
		</div>
	}
</div>
